<template>
	<sf-modal-layout size="xl" title="test" :show="show_" :closeModal="closeModal">
		<sf-data-table rowSize="lg" :columns="columns" :rows="rows" index height="100%"> </sf-data-table>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import { isNull, isUndefined } from '@/utils';

export default {
	methods: {
		...rootMethods,
		...serviceMethods,
		closeModal() {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: { show: false, result: {} }
			});
			//console.log('@@show_', this.show_);
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			//console.log('@@show_', this.show_);
			//console.log('@@this.popupParams.result', Object.keys(this.popupParams.result).length);
			if (Object.keys(this.popupParams.result).length != 0) {
				const keys = Object.keys(this.popupParams.result[0]);
				const columns = keys.map(v => ({ label: v, prop: v }));
				return columns;
			} else {
				return [];
			}
		},
		rows() {
			if (Object.keys(this.popupParams.result).length != 0) {
				return this.popupParams.result;
			} else {
				return [];
			}
		}
	}
};
</script>

<style langType="scss"></style>
